<template>
    <div id="portfolio-edit-page-container" v-if="isAuthenticated">
        
        <action-list :isExhibition="false"></action-list>

        <draggable-list 
            :artworkList="dataTobeSentAPI.data"
            @update:artworkList="dataTobeSentAPI.data = $event"
            :isExhibition="false"
            @openDeleteModal="openDeleteModal" 
            @openImageInfoModal="openImageInfoModal">
        </draggable-list >

        <div id="modal-container">
            
            <work-info-modal 
                :visible="isWorkInfoModalVisible"
                :artwork="selectedArtwork"
                :isExhibition="false"
                @confirm="handleWorkInfo"
                @cancel="closeWorkInfoModal">
            </work-info-modal>

            <delete-confirmation-modal 
                :visible="isDeleteConfirmationModalVisible"
                :orderNo="artworkOrderNoToBeDeleted"
                @confirm="handleDelete" 
                @cancel="closeDeleteModal"
                :isExhibition="false">
            </delete-confirmation-modal>


        </div>

    </div>
</template>

<script>
import DraggableList from '@/components/DraggableList.vue';
import ActionList from '@/components/ActionList.vue';
import WorkInfoModal from '@/components/edit-modals/WorkInfoModal.vue';
import DeleteConfirmationModal from '@/components/edit-modals/DeleteConfirmationModal.vue';
import axios from 'axios';

export default{
    components: {
        // draggableComponent: draggableComponent,
        "draggable-list": DraggableList,
        "action-list": ActionList,
        "work-info-modal": WorkInfoModal,
        "delete-confirmation-modal": DeleteConfirmationModal
    },

    data(){
        return{
            isAuthenticated: false,

            old: [],
            
            dataTobeSentAPI: {
                count: 0,
                data: []
            },

            isWorkInfoModalVisible : false,
            isImageUploadModalVisible : false,
            isDeleteConfirmationModalVisible : false,

            selectedArtwork: [],
            artworkOrderNoToBeDeleted: 0,
        }
    },

    methods:{
        //Delete operations
        openDeleteModal(artworkOrderNo){
            this.isDeleteConfirmationModalVisible = true;
            this.artworkOrderNoToBeDeleted = artworkOrderNo;
        },
        closeDeleteModal(){
            this.isDeleteConfirmationModalVisible = false;
        },
        handleDelete(artworkOrderNo){
            this.dataTobeSentAPI.data = this.dataTobeSentAPI.data.filter(item => item.orderNo !== artworkOrderNo);
            //console.log(this.dataTobeSentAPI);
            this.closeDeleteModal();
            window.location.reload();
        },

        //Artwork info edit operations
        openImageInfoModal(artworkOrderNo){
            this.isWorkInfoModalVisible = true;
            this.selectedArtwork = this.dataTobeSentAPI.data.find(x => x.orderNo == artworkOrderNo);
        },
        closeWorkInfoModal(){
            this.isWorkInfoModalVisible = false;
            this.selectedArtwork = [];
        },
        handleWorkInfo(updatedArtwork){
             // artworks dizisindeki ilgili öğeyi bul ve güncelle
            const index = this.dataTobeSentAPI.data.findIndex(x => x.orderNo === updatedArtwork.orderNo);
            if (index !== -1) {
                // Vue 3'te reaktivite Proxy tabanlı olduğu için doğrudan atama yapabilirsiniz
                this.dataTobeSentAPI.data[index] = updatedArtwork;
            }
            this.closeWorkInfoModal();
            window.location.reload();
        },

        //API operations
        async getPortfolioInfo(){
            try {
                // API çağrısını asenkron şekilde bekle
                const response = await axios.get("/api-path/Portfolio/get-all-images");

                // Axios, zaten JSON döndürdüğü için `response.data` yeterli
                const data = response.data;

                // Gelen veriyi değişkene map'le
                this.dataTobeSentAPI.count = data.count;
                this.dataTobeSentAPI.data = data.data;
                
            } catch (error) {
                console.error("API call failed:", error);
            }
        }
    },

    watch:{
        dataTobeSentAPI: {
            handler(newValue, oldValue) {
                this.dataTobeSentAPI = newValue;
                console.log(newValue);
                this.old = oldValue;
            },
            deep: true,
        },
    },

    mounted(){
        if (localStorage.getItem("confirmation") === "onaylandi") {
            this.isAuthenticated = true;
            if (!localStorage.getItem("portfolioPageRefreshed")) {
                // Sayfa daha önce yenilenmediyse, sayfayı yenile
                localStorage.setItem("portfolioPageRefreshed", "true");
                window.location.reload();
            }
            this.getPortfolioInfo();
        }else{
            this.isAuthenticated = false;
            this.$router.push('/site-settings');
        }
    }
}
</script>

<style scoped>

#portfolio-edit-page-container{
    width: 80vw;
    display: flex;
    flex-direction: column;
}

</style>